/* 壹品 手機版全站外框（階段 1）
   - <eepi-drawer>：<dialog> 選單抽屜。開關用 CSS transition（可中斷、可反轉），關閉等 transitionend 才 close()
   - <eepi-tabbar>：購物車數量同步標頭 #cart-icon-bubble（涵蓋加入購物車、購物車頁改數量等所有更新路徑）
   - [data-eepi-drawer-open]：全頁委派，標頭漢堡與 tab bar「分類」共用；回滾到 Dawn 抽屜時改開 Dawn 的漢堡 */
(function () {
  var CLOSE_FALLBACK_MS = 320; /* 退場 240ms＋緩衝；reduced motion 或 transitionend 沒觸發時的保底 */

  function setExpanded(open) {
    document.querySelectorAll('[data-eepi-drawer-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  class EepiDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.panel = this.querySelector('.eepi-drawer__panel');
      this.root = this.querySelector('[data-view-root]');
      this.sub = this.querySelector('[data-view-sub]');
      if (!this.dialog || !this.panel || !this.root || !this.sub) return;
      this.sub.inert = true;
      /* 舊瀏覽器（iOS <15.4）沒有 showModal：降級為以 open 屬性顯示的非 modal 抽屜，Esc 自己接 */
      this.native = typeof this.dialog.showModal === 'function';
      if (!this.native) {
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.dataset.state === 'open') this.close();
        });
      }

      this.dialog.addEventListener('click', (event) => {
        var push = event.target.closest('[data-eepi-push]');
        if (push) return this.push(push);
        if (event.target.closest('[data-eepi-back]')) return this.pop();
        if (event.target.closest('[data-eepi-drawer-close]')) this.close();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      /* 瀏覽器可能不經 cancel 直接關閉 dialog（例如沒有使用者手勢時按 Esc），同步回關閉狀態 */
      this.dialog.addEventListener('close', () => {
        if (this.dataset.state === 'closed') return;
        this.cancelClose();
        this.dataset.state = 'closed';
        document.documentElement.classList.remove('eepi-scroll-lock');
        setExpanded(false);
        this.reset();
      });

      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.onDesktop = (event) => {
        if (event.matches) this.close();
      };
      this.desktopQuery.addEventListener('change', this.onDesktop);
    }

    disconnectedCallback() {
      document.documentElement.classList.remove('eepi-scroll-lock');
      if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.onDesktop);
    }

    open(trigger) {
      if (!this.dialog) return;
      if (trigger) this.trigger = trigger;
      this.cancelClose();
      if (!this.dialog.hasAttribute('open')) {
        if (this.native) this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        this.panel.getBoundingClientRect(); /* 先套用關閉狀態，transition 才會從左側滑入 */
      }
      document.documentElement.classList.add('eepi-scroll-lock');
      this.dataset.state = 'open';
      setExpanded(true);
      this.bindSwipe();
    }

    close() {
      if (this.dataset.state !== 'open') return;
      this.dataset.state = 'closing';
      setExpanded(false);
      this.onTransitionEnd = (event) => {
        if (event && (event.target !== this.panel || (event.propertyName !== 'transform' && event.propertyName !== 'opacity'))) return;
        this.finishClose();
      };
      this.panel.addEventListener('transitionend', this.onTransitionEnd);
      this.closeTimer = setTimeout(this.onTransitionEnd, CLOSE_FALLBACK_MS);
    }

    cancelClose() {
      clearTimeout(this.closeTimer);
      if (this.onTransitionEnd) this.panel.removeEventListener('transitionend', this.onTransitionEnd);
      this.onTransitionEnd = null;
    }

    finishClose() {
      this.cancelClose();
      this.dataset.state = 'closed';
      if (this.native) this.dialog.close();
      else this.dialog.removeAttribute('open');
      document.documentElement.classList.remove('eepi-scroll-lock');
      this.reset();
      if (this.trigger && this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }

    /* 左滑關閉（Pointer Events）：移動 10px 後判定方向，垂直交還原生捲動；水平則 1:1 跟手、往右有阻尼；
       放開時速度 >0.11px/ms 或拖超過 30% 寬就關閉，否則彈回。減少動態時不啟用（面板改用淡入淡出） */
    bindSwipe() {
      if (this.swipeBound || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.swipeBound = true;
      var panel = this.panel;
      var overlay = this.querySelector('.eepi-drawer__overlay');
      var drag = null;
      var self = this;
      var setPos = function (x) {
        panel.style.transform = 'translateX(' + x + 'px)';
        if (overlay) overlay.style.opacity = Math.max(0, Math.min(1, 1 + x / panel.offsetWidth));
      };
      var restore = function (closing) {
        panel.style.transition = '';
        if (overlay) overlay.style.transition = '';
        panel.style.transform = '';
        if (overlay) overlay.style.opacity = '';
        if (closing) self.close();
      };
      panel.addEventListener('pointerdown', function (event) {
        if (self.dataset.state !== 'open' || event.pointerType === 'mouse' || !event.isPrimary) return;
        drag = { id: event.pointerId, x0: event.clientX, y0: event.clientY, axis: null, x: 0, px: 0, pt: event.timeStamp, t: event.timeStamp, v: 0 };
      }, { passive: true });
      panel.addEventListener('pointermove', function (event) {
        if (!drag || event.pointerId !== drag.id) return;
        var dx = event.clientX - drag.x0, dy = event.clientY - drag.y0;
        if (!drag.axis) {
          if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
          drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (drag.axis === 'y') return;
          try { panel.setPointerCapture(drag.id); } catch (e) { /* 舊瀏覽器 */ }
          panel.style.transition = 'none';
          if (overlay) overlay.style.transition = 'none';
        }
        if (drag.axis !== 'x') return;
        var x = dx > 0 ? dx * 0.2 : dx; /* 往右超出邊界：阻尼 */
        /* 速度取最近約 80ms 的位移平均，避免最後一小段抖動誤判 */
        drag.hist = drag.hist || [];
        drag.hist.push({ x: x, t: event.timeStamp });
        while (drag.hist.length > 2 && event.timeStamp - drag.hist[0].t > 80) drag.hist.shift();
        var first = drag.hist[0];
        drag.v = (x - first.x) / Math.max(1, event.timeStamp - first.t);
        drag.x = x; drag.t = event.timeStamp;
        setPos(x);
      }, { passive: true });
      var end = function (event) {
        if (!drag || event.pointerId !== drag.id) return;
        var d = drag; drag = null;
        if (d.axis !== 'x') return;
        var shouldClose = event.type !== 'pointercancel' && (d.v < -0.11 || d.x < -panel.offsetWidth * 0.3);
        /* 先還原 transition，再在同一幀移除行內 transform，CSS 會從目前位置接手動畫 */
        panel.style.transition = '';
        if (overlay) overlay.style.transition = '';
        panel.getBoundingClientRect();
        restore(shouldClose);
      };
      panel.addEventListener('pointerup', end);
      panel.addEventListener('pointercancel', end);
    }

    push(button) {
      var template = document.getElementById(button.getAttribute('data-eepi-push'));
      if (!template) return;
      this.sub.replaceChildren(template.content.cloneNode(true));
      this.sub.scrollTop = 0;
      this.pushButton = button;
      button.setAttribute('aria-expanded', 'true');
      this.root.inert = true;
      this.sub.inert = false;
      this.dataset.depth = '1';
      var back = this.sub.querySelector('[data-eepi-back]');
      if (back) back.focus({ preventScroll: true });
    }

    pop() {
      this.reset();
      if (this.pushButton) this.pushButton.focus({ preventScroll: true });
    }

    reset() {
      this.dataset.depth = '0';
      this.sub.inert = true;
      this.root.inert = false;
      if (this.pushButton) this.pushButton.setAttribute('aria-expanded', 'false');
      if (this.dataset.state === 'closed') this.root.scrollTop = 0;
    }
  }

  class EepiTabbar extends HTMLElement {
    connectedCallback() {
      this.badge = this.querySelector('[data-cart-count]');
      this.label = this.querySelector('[data-cart-label]');
      if (!this.badge) return;
      this.bind();
      /* 標頭 section 在編輯器重繪時會換掉 #cart-icon-bubble，重新綁定觀察器 */
      this.onSectionLoad = () => this.bind();
      document.addEventListener('shopify:section:load', this.onSectionLoad);
    }

    bind() {
      if (this.observer) this.observer.disconnect();
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble) return;
      var badge = this.badge;
      var label = this.label;
      var sync = function () {
        var wrap = bubble.querySelector('.cart-count-bubble');
        var number = wrap && wrap.querySelector('span[aria-hidden]');
        var text = wrap ? (number ? number.textContent.trim() : '99+') : '';
        var hidden = wrap && wrap.querySelector('.visually-hidden');
        badge.textContent = text;
        badge.hidden = !text;
        if (label) label.textContent = hidden ? hidden.textContent.trim() : '';
      };
      this.observer = new MutationObserver(sync);
      this.observer.observe(bubble, { childList: true, subtree: true, characterData: true });
      sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onSectionLoad) document.removeEventListener('shopify:section:load', this.onSectionLoad);
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-eepi-drawer-open]');
    if (!trigger) return;
    var drawer = document.querySelector('eepi-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(trigger);
      return;
    }
    var dawnSummary = document.querySelector('#Details-menu-drawer-container > summary');
    if (dawnSummary) dawnSummary.click();
  });

  /* 主題編輯器：選到抽屜裡的區塊（焦點單元／會員快捷）時自動打開抽屜；桌機（≥990px）抽屜是隱藏的，不動作 */
  function editorDrawer(event) {
    if (window.matchMedia('(min-width: 990px)').matches) return null;
    var drawer = document.querySelector('eepi-drawer');
    return drawer && drawer.contains(event.target) ? drawer : null;
  }
  document.addEventListener('shopify:block:select', function (event) {
    var drawer = editorDrawer(event);
    if (drawer && typeof drawer.open === 'function') drawer.open();
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var drawer = editorDrawer(event);
    if (drawer && typeof drawer.close === 'function') drawer.close();
  });

  /* 分類頁／搜尋頁手機排序（facets.liquid 的 [data-eepi-sort]）：改變即重繪，不等 Dawn 表單的 800ms 節流；
     同步其他 sort_by select，讓之後在抽屜勾篩選時帶的排序一致；換排序回到第 1 頁；返回鍵時從網址還原 */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-eepi-sort]');
    if (!select) return;
    var params = new URLSearchParams(location.search);
    params.set('sort_by', select.value);
    params.delete('page');
    document.querySelectorAll('select[name="sort_by"]').forEach(function (other) { other.value = select.value; });
    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(params.toString(), null);
    } else {
      location.search = params.toString();
    }
  });
  /* 浮動鈕（LINE、Ako）手機版：往下捲時收到右側外面，往上捲或回到頂部再出現，不再壓在商品列與文字上 */
  (function () {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var last = window.scrollY, raf = 0, html = document.documentElement;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var y = window.scrollY;
        if (y > last + 8 && y > 120) html.classList.add('eepi-floats-hide');
        else if (y < last - 8 || y <= 0) html.classList.remove('eepi-floats-hide');
        last = y;
      });
    }, { passive: true });
  })();

  window.addEventListener('popstate', function () {
    var select = document.querySelector('[data-eepi-sort]');
    var value = new URLSearchParams(location.search).get('sort_by');
    if (select && value) select.value = value;
  });

  if (!customElements.get('eepi-drawer')) customElements.define('eepi-drawer', EepiDrawer);
  if (!customElements.get('eepi-tabbar')) customElements.define('eepi-tabbar', EepiTabbar);
})();
